<template>
  <div>
    <treeselect v-model="value" :multiple="true" :options="options" />
    <button type="button" @click="ceshi">wwwwwwww</button>
  </div>

</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    name: "treeSelect",
    components: { Treeselect },
    data() {
      return {
        // define the default value
        value: ["a"],
        // define options
        options: [{
          id: 'a',
          label: 'a',
          children: [{
            id: 'aa',
            label: 'aa',
          }, {
            id: 'ab',
            label: 'ab',
          }],
        }, {
          id: 'b',
          label: 'b',
        }, {
          id: 'c',
          label: 'c',
        }],
      }
    },
    methods:{
        ceshi(){
          console.log(this.value)
        }
    }
  };
</script>

<style scoped>

</style>
